import { getLayer, IFeature } from '@esri/arcgis-rest-feature-layer';
import { Feature } from 'geojson';
import { Observable, Subscriber, TeardownLogic, from } from 'rxjs';
import { switchMap, share } from 'rxjs/operators';
import { WebSocketSubject } from 'rxjs/webSocket';

import { arcgisToGeoJSON, arcgisAttributesToProperties } from '../helpers';
import { IStreamLayerDefinition } from './stream-layer-definition';

export class StreamLayer extends Observable<Feature> {
  private readonly _socketConnection$: Observable<Feature>;

  constructor(url: string) {
    super();

    this._socketConnection$ = from(getLayer({ url })).pipe(
      switchMap(this._createSocketConnection.bind(this)),
      share(),
    );
  }

  /** @internal This is an internal implementation detail, do not use. */
  public _subscribe(subscriber: Subscriber<any>): TeardownLogic {
    return this._socketConnection$.subscribe(subscriber);
  }

  private _createSocketConnection(definition: IStreamLayerDefinition): WebSocketSubject<Feature> {
    const streamUrl = definition.streamUrls[0];

    let socketUrl = `${streamUrl.urls[0]}/subscribe`;

    if (streamUrl.token) {
      socketUrl += `?token=${streamUrl.token}`;
    }

    return new WebSocketSubject({
      url: socketUrl,
      deserializer: (message: MessageEvent) => this._socketDeserializer(message, definition),
    });
  }

  private _socketDeserializer(message: MessageEvent, definition: IStreamLayerDefinition): Feature {
    const data: IFeature = JSON.parse(message.data);
    const idAttribute = definition.objectIdField || definition.displayField;

    const feature = arcgisToGeoJSON(data, idAttribute);
    feature.properties = arcgisAttributesToProperties(data.attributes, definition.fields);

    return feature;
  }
}
